module.exports = {
      id: "whatsapp-usage",
      viewBox: "0 0 135.081 135.08",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }